import { TableV2 } from '@anytag/shared-atoms';
import { TableData } from '@anytag/shared-types';
import { YoutubeAnalyticsTagRankingPayload } from '@anytag/graphql';
import { useAnalyticsYoutubeTagsRankingListTable } from './hooks';

export interface AnalyticsYoutubeTagsRankingListProps extends TableData<YoutubeAnalyticsTagRankingPayload> {
  className?: string;
}

export const AnalyticsYoutubeTagsRankingList = ({
  loading,
  className,
  data = []
}: AnalyticsYoutubeTagsRankingListProps) => {
  const { columns } = useAnalyticsYoutubeTagsRankingListTable();

  return (
    <TableV2
      loading={loading}
      className={className}
      data={data}
      columns={columns}
      rowHeight="40px"
      noTopBorderRadius
      hasBorder
    />
  );
};
